/* eslint-disable */

export const dataInputsBanks = [
  {
    id: '1',
    nameInput: 'bancoBCI',
    name: 'Banco BCI',
    icono: require('../../../../../../assets/iconosBancos/bancoBCI.jpeg'),
    nameBD: 'bci'
  },
  {
    id: '2',
    nameInput: 'bancoConsorcio',
    name: 'Banco Consorcio',
    icono: require('../../../../../../assets/iconosBancos/bancoConsorcio.jpeg'),
    nameBD: 'consorcio'
  },
  {
    id: '3',
    nameInput: 'bancoSantander',
    name: 'Banco Santander',
    icono: require('../../../../../../assets/iconosBancos/bancoSantander.jpeg'),
    nameBD: 'santander'
  },
  {
    id: '4',
    nameInput: 'bancoItau',
    name: 'Banco Itau',
    icono: require('../../../../../../assets/iconosBancos/bancoItau.jpeg'),
    nameBD: 'itau'
  },
  {
    id: '5',
    nameInput: 'bancoSecurity',
    name: 'Banco Security',
    icono: require('../../../../../../assets/iconosBancos/bancoSecurity.jpeg'),
    nameBD: 'bancosecurity'
  },
  {
    id: '6',
    nameInput: 'bancoChile',
    name: 'Banco Chile',
    icono: require('../../../../../../assets/iconosBancos/bancoChile.jpeg'),
    nameBD: 'bancochile'
  },
  {
    id: '7',
    nameInput: 'bancoEstado',
    name: 'Banco Estado',
    icono: require('../../../../../../assets/iconosBancos/bancoEstado.jpeg'),
    nameBD: 'bancoestado'
  },
  {
    id: '8',
    nameInput: 'bancoInternacional',
    name: 'Banco Internacional',
    icono: require('../../../../../../assets/iconosBancos/bancoInternacional.jpeg'),
    nameBD: 'internacional'
  },
  {
    id: '9',
    nameInput: 'bancoScotiabank',
    name: 'Banco Scotiabank',
    icono: require('../../../../../../assets/iconosBancos/bancoScotiabank.jpeg'),
    nameBD: 'scotiabank'
  },
  {
    id: '10',
    nameInput: 'bancoBice',
    name: 'Banco Bice',
    icono: require('../../../../../../assets/iconosBancos/bancoBice.jpeg'),
    nameBD: 'bice'
  }
]

export const firstObjectListAcountBank = {
  id: 0,
  bancoCuentaId: null,
  numeroCuenta: null,
  cuentaTipoId: null,
  tipoDivisaId: null,
  saldo: null,
  updatedAt: null,
  cuentaTipo: { id: null, name: null },
  tipoDivisa: { id: null, name: null },
  bancoCuenta: {
    id: null,
    businessId: null,
    bankId: null,
    rutPersona: null,
    role: null,
    convenio: null,
    bank: { id: null, name: null }
  }
}

export const bankIcons = {
  'Banco BICE': require('../../../../../../assets/iconosBancos/bancoBice.jpeg'),
  'Banco de Chile': require('../../../../../../assets/iconosBancos/bancoChile.jpeg'),
  'Banco Estado': require('../../../../../../assets/iconosBancos/bancoEstado.jpeg'),
  'Banco Internaci': require('../../../../../../assets/iconosBancos/bancoInternacional.jpeg'),
  'Banco Santander': require('../../../../../../assets/iconosBancos/bancoSantander.jpeg'),
  'Banco Security': require('../../../../../../assets/iconosBancos/bancoSecurity.jpeg'),
  'Banco BCI': require('../../../../../../assets/iconosBancos/bancoBCI.jpeg'),
  'Banco BCI 360': require('../../../../../../assets/iconosBancos/bancoBCI.jpeg'),
  'Banco Consorcio': require('../../../../../../assets/iconosBancos/bancoConsorcio.jpeg'),
  'Banco Itaú': require('../../../../../../assets/iconosBancos/bancoItau.jpeg'),
  'Banco Scotiabank': require('../../../../../../assets/iconosBancos/bancoScotiabank.jpeg'),
  'Mercado Pago': require('../../../../../../assets/iconosBancos/mercadoPago.jpg'),
  'MercadoPago': require('../../../../../../assets/iconosBancos/mercadoPago.jpg'),
  'Mercadopago': require('../../../../../../assets/iconosBancos/mercadoPago.jpg'),
  Global66: require('../../../../../../assets/iconosBancos/global66.png')
}

export const folioCreditoLabels = {
  0: 'Pago Arriendos',
  1: 'Cobro Arriendos',
  2: 'Gastos Comunes',
  3: 'Retiro Dividendo',
  4: 'Prestamo Otorgado',
  5: 'Cobro Cuota Prestamo',
  6: 'Credito Consumo',
  7: 'Pago Cuota Prestamo',
  8: 'Pago Patente Comercial',
  9: 'Pago Contribuciones',
  10: 'Aporte Transitorio Socio',
  11: 'Devolucion Aporte Transitorio',
  12: 'Rendicion Gastos',
  13: 'Invoice Compra',
  14: 'Invoice Venta',
  15: 'Finiquitos',
  16: 'Inversiones dap',
  17: 'Inversiones ffmm',
  18: 'Inversiones otras',
  19: 'Acciones en bolsa',
  20: 'Criptomonedas',
  21: 'Otros valores negociables',
  22: 'Ajuste Existencias',
  23: 'Pago año anterior',
  24: 'Cobro año anterior',
  25: 'Vinculación Generica Cargo',
  26: 'Vinculación Generica Abono',
  27: 'Anticipo Agente Aduana',
  28: 'Anticipo Sueldo',
  29: 'Multas',
  30: 'Devolución Agente Aduana',
  31: 'Previred año anterior',
  32: 'Remuneración año anterior',
  33: 'Aporte Empresa Relacionada',
  34: 'Devolución Empresa Relacionada',
  35: 'Invoice Importaciones',
  36: 'Devolución de Impuestos',
}

export const isF29Movement = item =>
  [item?.origenTabla, item?.tablaPrincipal, item?.libroContableOriginTableId]
    .some(value => Number(value) === 39)

export const getFolioCreditoLabel = item => {
  if (isF29Movement(item)) return ''
  const value = item?.folioCredito
  if (value === null || value === undefined || value === '') return ''
  return folioCreditoLabels[Number(value)] || ''
}
